function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 500 234"
}, props), React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("path", {
  d: "M10 15c0-5.523 4.477-10 10-10h460c5.523 0 10 4.477 10 10v77c0 5.523-4.477 10-10 10H20c-5.523 0-10-4.477-10-10V15z",
  fill: "#fff"
})), React.createElement("rect", {
  width: "260",
  height: "25",
  rx: "5",
  transform: "matrix(1 0 0 -1 110 80)",
  fill: "#F2F2F2"
}), React.createElement("path", {
  d: "M40 40c0-5.523 4.477-10 10-10h30c5.523 0 10 4.477 10 10v30c0 5.523-4.477 10-10 10H50c-5.523 0-10-4.477-10-10V40z",
  fill: "#E52F00"
}), React.createElement("path", {
  opacity: ".5",
  d: "M68.79 64l-.914-3.478h-6.03L60.906 64h-5.509l6.056-18.637h6.69L74.275 64h-5.484zm-1.955-7.592l-.8-3.047c-.185-.677-.414-1.553-.685-2.628a45.433 45.433 0 01-.52-2.31 47.705 47.705 0 01-.457 2.133c-.22.99-.716 2.94-1.486 5.852h3.948z",
  fill: "#fff"
}), React.createElement("rect", {
  x: "110",
  y: "30",
  width: "130",
  height: "15",
  rx: "2",
  fill: "#F2F2F2"
}), React.createElement("g", {
  filter: "url(#filter1_d)"
}, React.createElement("path", {
  d: "M10 132c0-5.523 4.477-10 10-10h460c5.523 0 10 4.477 10 10v77c0 5.523-4.477 10-10 10H20c-5.523 0-10-4.477-10-10v-77z",
  fill: "#fff"
})), React.createElement("rect", {
  width: "260",
  height: "25",
  rx: "5",
  transform: "matrix(1 0 0 -1 110 197)",
  fill: "#F2F2F2"
}), React.createElement("path", {
  d: "M40 157c0-5.523 4.477-10 10-10h30c5.523 0 10 4.477 10 10v30c0 5.523-4.477 10-10 10H50c-5.523 0-10-4.477-10-10v-30z",
  fill: "#2655BD"
}), React.createElement("path", {
  opacity: ".5",
  d: "M58.089 162.439h6.474c2.522 0 4.393.377 5.611 1.13 1.228.745 1.841 1.909 1.841 3.492 0 1.041-.266 1.929-.8 2.666a3.565 3.565 0 01-2.107 1.421v.127c1.151.305 1.985.813 2.501 1.524.516.711.774 1.633.774 2.767 0 1.685-.634 3.013-1.904 3.987-1.261.965-2.983 1.447-5.167 1.447H58.09v-18.561zm5.014 7.123h1.51c.72 0 1.275-.149 1.664-.445.398-.296.597-.736.597-1.32 0-1.041-.787-1.562-2.362-1.562h-1.409v3.327zm0 3.668v3.898h1.765c1.566 0 2.348-.66 2.348-1.981 0-.617-.211-1.091-.634-1.421-.415-.33-1.02-.496-1.816-.496h-1.663z",
  fill: "#fff"
}), React.createElement("rect", {
  x: "110",
  y: "147",
  width: "130",
  height: "15",
  rx: "2",
  fill: "#F2F2F2"
}), React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: "0",
  y: "0",
  width: "500",
  height: "117",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "5"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "5"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter1_d",
  x: "0",
  y: "117",
  width: "500",
  height: "117",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "5"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "5"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));